import React from "react";
import {
  HomePage,
  AboutPage,
  ErrorPage,
  ProductsPage,
  CartPage,
  SingleProductPage,
  AuthWrapper,
  PrivateRoute,
  CheckoutPage,
} from "./pages";
import { Footer, NavBar, Sidebar } from "./components";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

const App = () => {
  return (
    <AuthWrapper>
      <Router>
        <NavBar />
        <Sidebar />
        <Switch>
          <Route exact path="/">
            <HomePage />
          </Route>
          <Route path="/about">
            <AboutPage />
          </Route>
          <Route exact path="/products">
            <ProductsPage />
          </Route>
          <Route path="/products/:id" children={<SingleProductPage />} />

          <Route path="/cart">
            <CartPage />
          </Route>
          <PrivateRoute path="/checkout">
            <CheckoutPage />
          </PrivateRoute>
          <Route path="*">
            <ErrorPage />
          </Route>
        </Switch>
      </Router>
      <Footer />
    </AuthWrapper>
  );
};

export default App;
